// Frontend form configuration + submission helper for the Phase 8A lead forms.
// No credentials or list IDs live here — the backend resolves Constant Contact
// list IDs server-side. Forms operate against the backend (test mode by default).

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Display name -> backend form key.
export const FORM_KEY_BY_LIST = {
  "7 Simple Steps to Becoming Your Own Banker": "7-steps",
  "Legacy Builder Outline": "legacy-builder",
  "Budget Template + Training": "budget-template",
  "The Infinite Banking Guide": "infinite-banking-guide",
  "Save & Spend System Overview": "save-spend-overview",
  "Weekly newsletter sign ups": "newsletter",
};

export const absoluteBackendUrl = (path) => `${BACKEND}${path}`;

const utmFromLocation = () => {
  if (typeof window === "undefined") return {};
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get("utm_source") || undefined,
    utm_medium: p.get("utm_medium") || undefined,
    utm_campaign: p.get("utm_campaign") || undefined,
    page_path: window.location.pathname,
  };
};

export async function submitForm(formKey, { firstName, email, consent, source, company, consentVersion, idempotencyKey }) {
  const res = await fetch(`${BACKEND}/api/forms/${formKey}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      first_name: firstName,
      email,
      consent,
      form_source: source,
      company, // honeypot
      consent_version: consentVersion,
      idempotency_key: idempotencyKey,
      ...utmFromLocation(),
    }),
  });
  const data = await res.json().catch(() => ({ status: "cc_error", message: "Something went wrong. Please try again." }));
  return data;
}

export async function fetchConsentCopy() {
  try {
    const res = await fetch(`${BACKEND}/api/forms/consent`);
    return await res.json();
  } catch {
    return { version: "v2026.06-draft", text: "Yes, I agree to receive educational emails from Legacy Life & Retirement. I understand I can unsubscribe at any time." };
  }
}

export async function fetchSaveSpendVideo(accessUrl) {
  const res = await fetch(`${BACKEND}${accessUrl}`);
  return await res.json();
}
